import { createContext } from 'react';

export type FilterPickerFilterFunction<T = unknown> = (value: T) => boolean;

export type FilterPickerContextProps<T = unknown> = Partial<
  Record<string, FilterPickerFilterFunction<T>>
>;

const defaultFilterPickerContext: FilterPickerContextProps = {};

const FilterPickerContext = createContext<FilterPickerContextProps>(
  defaultFilterPickerContext
);

export default FilterPickerContext;
